import React from "react";
import ViewTemplate from "../../../components/MainTemplate/ViewTemplate";

const ExpenseView = ({ currentRecord }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  };

  const data = {
    date: formatDate(currentRecord?.date),
    voucher_number: currentRecord?.voucher_number,
    category_name: currentRecord?.category_id?.category_name,
    expense_title: currentRecord?.expense_title,
    description: currentRecord?.description,
    member_name: currentRecord?.member_id?.first_name
      ? currentRecord?.member_id?.first_name +
        " " +
        currentRecord?.member_id?.last_name
      : "Third Party",
    mobile: currentRecord?.member_id?.mobile,
    amount: currentRecord?.amount,
    transfer_source: currentRecord?.transfer_source,
    church_name: currentRecord?.church_id?.church_name,
  };

  let componentRef = React.useRef();

  return <ViewTemplate data={data} />;
};

export default ExpenseView;
